import React from 'react'

function AgeRestrictionsDiv(props) {
  const { changeCategoryAge, statusType, agevalue, ageRestrictionClear } = props
  return (
    <div className='agerestriction d-flex'>
      <div>
        <label>Age Restriction</label>
        <select
          disabled={statusType === 'draft'}
          onChange={changeCategoryAge}
          required
          value={agevalue}
          name='select'
          id='languages'
        >
          <option value='' disabled selected>
            Age Restriction
          </option>
          <option value='none' selected={agevalue === 'none'}>
            none
          </option>
          <option value='U' selected={agevalue === 'U'}>
            U
          </option>
          <option value='UA' selected={agevalue === 'UA'}>
            U/A
          </option>
          <option value='A' selected={agevalue === 'A'}>
            A
          </option>
          <option value='S' selected={agevalue === 'S'}>
            S
          </option>
        </select>
        {/* <Select
          isDisabled={statusType === 'draft'}
          options={appInfoServiceData && appInfoServiceData.ageRestrictionFilters}
          // isMulti
          value={agevalue}
          name='genre'
          className='basic-multi-select'
          classNamePrefix='select'
          onChange={selectedOption => changeCategoryAge(selectedOption)}
        /> */}
      </div>
      <div className='d-flex align-items-end'>
        <button
          style={{ padding: '1px 7px', marginLeft: '4px' }}
          onClick={ageRestrictionClear}
          className='btn btn-primary'
        >
          x
        </button>
      </div>
    </div>
  )
}

export default AgeRestrictionsDiv
